var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDragDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: " ",
    d: "M186.58-.1H-.1V186.58H186.58Zm-15,171.68H14.9V14.9H171.58Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 67.92,
    y: 239.25,
    width: 16.41,
    height: 16.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 67.92,
    y: 204.75,
    width: 16.41,
    height: 17.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 205.09,
    y: 67.58,
    width: 17.25,
    height: 16.41
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 67.58,
    width: 16.41,
    height: 16.41
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 170.25,
    width: 16.41,
    height: 17.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 101.24,
    width: 16.41,
    height: 17.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 204.75,
    width: 16.41,
    height: 17.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 135.74,
    width: 16.41,
    height: 17.25
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 239.59,
    y: 239.25,
    width: 16.41,
    height: 16.41
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 205.09,
    y: 239.25,
    width: 17.25,
    height: 16.41
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 170.58,
    y: 239.25,
    width: 17.25,
    height: 16.41
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 101.58,
    y: 239.25,
    width: 17.25,
    height: 16.41
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: " ",
    x: 136.08,
    y: 239.25,
    width: 17.25,
    height: 16.41
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: " ",
    points: "83.04 141.37 83.04 156.37 139.81 156.37 154.55 156.37 154.81 156.37 154.81 84.86 139.81 84.86 139.81 131.1 69.12 60.41 58.51 71.01 128.87 141.37 83.04 141.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragDrop);
export default __webpack_public_path__ + "static/media/icon-drag-drop.5bf389b5.svg";
export { ForwardRef as ReactComponent };